export default __webpack_public_path__ + "static/media/cutting-4.752167cd.webp";